import { motion } from "framer-motion";
import { PRODUCTS } from "../../data/content";

const StatusBadge = ({ status }) => {
  const delivered = status === "Delivered";
  return (
    <span
      data-testid="product-status-badge"
      className={`inline-flex items-center gap-2 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em] border ${
        delivered ? "border-[#1E4D8B] text-[#1E4D8B]" : "border-[#F5B800] text-[#b98a00]"
      }`}
    >
      <span className={`w-1.5 h-1.5 ${delivered ? "bg-[#1E4D8B]" : "bg-[#F5B800]"}`} />
      {status}
    </span>
  );
};

export const Products = () => {
  return (
    <section id="products" data-testid="products-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-10 bg-[#F5B800]" />
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1C9FD8]">Products</p>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-slate-900">
            Delivered & under development.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed">
            Real-world embedded and IoT systems, engineered end to end.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-slate-200 border border-slate-200">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid="product-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
              className={`group bg-white p-8 lg:p-10 hover:bg-[#F8FAFC] transition-colors ${p.span}`}
            >
              <StatusBadge status={p.status} />
              <h3 className="mt-6 font-display text-xl lg:text-2xl font-semibold tracking-tight text-slate-900 group-hover:text-[#1E4D8B] transition-colors leading-snug">
                {p.title}
              </h3>
              <p className="mt-3 text-sm lg:text-base text-slate-600 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
